export const PHONE_DISPLAY = "+91 89997 22515";
export const PHONE_TEL = "+918999722515";
export const WHATSAPP_NUMBER = "918999722515";
export const WHATSAPP_LINK = "https://wa.me/918999722515";
export const EMAIL = "hello@rajgraphics.in";

export const buildWhatsAppLink = (text) =>
    `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(text)}`;

export const CONSULT_MESSAGE = "Hi! I'd like a free consultation for my brand";
export const CONSULT_LINK = buildWhatsAppLink(CONSULT_MESSAGE);

export const FREE_AUDIT_MESSAGE = "Hi! I want to claim the Free Brand Audit";
export const FREE_AUDIT_LINK = buildWhatsAppLink(FREE_AUDIT_MESSAGE);
